import Immutable from 'immutable';
import omit from 'lodash/omit';

export interface RawUploadData {
  projectid: string;
  filename: string;
  category: string;
  extension: string;
  filesize: number;
  file?: File | null;
}

const defaultValues: RawUploadData = {
  projectid: '',
  filename: '',
  category: '',
  extension: '',
  filesize: 0,
  file: null,
};

export const UploadDataFactory = Immutable.Record(defaultValues, 'UploadData');

export class UploadData extends UploadDataFactory {
  serialize(): RawUploadData {
    return omit(this.toJS(), ['file']);
  }

  static deserialize(rawUploadData: RawUploadData): UploadData {
    return new UploadData({
      ...rawUploadData,
    });
  }
}

export type UploadDataList = Immutable.List<UploadData>;
